module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    class: _vm.caption
  }, [(_vm.icon) ? _c('fa', {
    class: _vm.caption,
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "caption-subject sbold"
  }, [_vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), (!!_vm.summary) ? _c('span', {
    staticClass: "caption-helper"
  }, [_vm._v(" " + _vm._s(_vm.summary))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_vm._t("actions")], 2), _vm._v(" "), (_vm.tools) ? _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('合并 / 展开'),
      expression: "'合并 / 展开'"
    }],
    staticClass: "collapse",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.fold
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('设置'),
      expression: "'设置'"
    }],
    staticClass: "config",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.config
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('刷新'),
      expression: "'刷新'"
    }],
    staticClass: "reload",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.reload
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('全屏'),
      expression: "'全屏'"
    }],
    staticClass: "fullscreen",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.fullscreen
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('移除'),
      expression: "'移除'"
    }],
    staticClass: "remove",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.remove
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f52d752"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/portlet/portlet.vue
// module id = 536
// module chunks = 84